module.exports = __webpack_public_path__ + "media/images/stock_photography/criss_crossed_grass-25c1656130e8e03cc04df5bce89f3dd7.jpg";